/**
 * IPAMLayout — envoltorio de las pantallas de Redes / IPAM.
 *
 * Antes pintaba una barra de pestañas HORIZONTAL con un array `TABS`
 * hardcodeado que era copia literal del grupo `ipam` de `menuConfig.js`: la
 * misma navegación dos veces (la lateral y esa), y encima se desincronizaba
 * (ocultar el grupo en el menú lateral no quitaba las pestañas).
 *
 * Ahora es solo el envoltorio: la navegación es la del menú lateral y cada
 * pantalla pinta su propia cabecera (las listas, con `ListPage`). Los enlaces
 * entre pantallas siguen usando query params (`?blockId=X&subnetId=Y`).
 */
import React from 'react';
import '../styles/ipam.css';

function IPAMLayout({ children }) {
  return (
    <div className="ipam-root">
      <div className="p-3">
        {children}
      </div>
    </div>
  );
}

export default IPAMLayout;
